import { Box, Typography, Chip, Stack } from '@mui/material'

interface LegendItem {
  color: string
  label: string
}

const LEGEND_ITEMS: LegendItem[] = [
  { color: '#ADD8E6', label: 'Largest Position' },
  { color: '#9370DB', label: 'New Stocks Today' },
  { color: '#FFFF00', label: '30 days or less to Target Date' },
  { color: '#90EE90', label: 'Has Already Traded Above Target' },
  { color: '#FFDAB9', label: 'Hit new price target today' },
  { color: '#FF6B6B', label: 'Stop Loss Price' }
]

const PositionsLegend: React.FC = () => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='subtitle2' fontWeight='bold' sx={{ mb: 1.5 }}>
        Position Color Legend
      </Typography>
      <Stack
        direction='row'
        spacing={1}
        flexWrap='wrap'
        useFlexGap
        sx={{ gap: 1 }}
      >
        {LEGEND_ITEMS.map((item, index) => (
          <Chip
            key={index}
            label={item.label}
            size='small'
            sx={{
              backgroundColor: item.color,
              color: item.color === '#FFFF00' || item.color === '#90EE90' || item.color === '#FFDAB9' || item.color === '#ADD8E6'
                ? 'rgba(0,0,0,0.87)'
                : 'white',
              fontWeight: 500,
              '& .MuiChip-label': {
                px: 1.5
              }
            }}
          />
        ))}
      </Stack>
    </Box>
  )
}

export default PositionsLegend
